<template>
  <a @click="$emit('give-pdf-pass')">
    <img :src="iconPath('v_print.svg')" alt="" class="icon-pdf">
    {{ this.title }}
  </a>
</template>

<script>
export default {
  name: 'PrintPassButton',
  props: {
    title: {
      type: String,
      required: true
    }
  },

  methods: {
    iconPath(baseName) {
      return require('@/common/assets/img/icons/menuVisitor/' + baseName)
    }
  }
}
</script>
